import { render } from "./EndYear.vue?vue&type=template&id=f8f28626&scoped=true"
import script from "./EndYear.vue?vue&type=script&lang=js"
export * from "./EndYear.vue?vue&type=script&lang=js"

import "./EndYear.vue?vue&type=style&index=0&id=f8f28626&scoped=true&lang=css"

import exportComponent from "/home/runner/work/metal-client/metal-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f28626"]])

export default __exports__